// extracted by mini-css-extract-plugin
export var btn = "main-module--btn--143f8";
export var titleBig = "main-module--title-big--5c5f2";
export var titleSmall = "main-module--title-small--f440b";